export { c as color, g as default, g as getColour, i as isHex } from '../../dist/getColour-41851c9a.esm.js';
import '../../utils/dist/commons.esm.js';
import 'styled-components';
import 'react';

// @ts-expect-error
function createOverrides(overrides) {
  var overrideMap = new Map();
  overrides === null || overrides === void 0 || overrides.forEach(item => overrideMap.set(item[0], item[1]));
  return overrideMap;
}

var removeHash = hex => hex.charAt(0) === '#' ? hex.slice(1) : hex;
var parseHex = nakedHex => {
  var isShort = nakedHex.length === 3 || nakedHex.length === 4;
  var twoDigitHexR = isShort ? "".concat(nakedHex.slice(0, 1)).concat(nakedHex.slice(0, 1)) : nakedHex.slice(0, 2);
  var twoDigitHexG = isShort ? "".concat(nakedHex.slice(1, 2)).concat(nakedHex.slice(1, 2)) : nakedHex.slice(2, 4);
  var twoDigitHexB = isShort ? "".concat(nakedHex.slice(2, 3)).concat(nakedHex.slice(2, 3)) : nakedHex.slice(4, 6);
  var twoDigitHexA = (isShort ? "".concat(nakedHex.slice(3, 4)).concat(nakedHex.slice(3, 4)) : nakedHex.slice(6, 8)) || 'ff';

  // const numericA = +((parseInt(a, 16) / 255).toFixed(2));

  return {
    r: twoDigitHexR,
    g: twoDigitHexG,
    b: twoDigitHexB,
    a: twoDigitHexA
  };
};
var hexToDecimal = hex => parseInt(hex, 16);
var hexesToDecimals = _ref => {
  var {
    r,
    g,
    b,
    a
  } = _ref;
  return {
    r: hexToDecimal(r),
    g: hexToDecimal(g),
    b: hexToDecimal(b),
    a: +(hexToDecimal(a) / 255).toFixed(2)
  };
};
var isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n); // eslint-disable-line no-restricted-globals, max-len

var formatRgb = (decimalObject, parameterA) => {
  var {
    r,
    g,
    b,
    a: parsedA
  } = decimalObject;
  var a = isNumeric(parameterA) ? parameterA : parsedA;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
};

/**
 * Turns an old-fashioned css hex colour value into a rgb colour value.
 *
 * If you specify an alpha value, you'll get a rgba() value instead.
 *
 * @param The hex value to convert. ('123456'. '#123456', ''123', '#123')
 * @param An alpha value to apply. (optional) ('0.5', '0.25')
 * @return An rgb or rgba value. ('rgb(11, 22, 33)'. 'rgba(11, 22, 33, 0.5)')
 */
var hexToRgba = (hex, a) => {
  var hashlessHex = removeHash(hex);
  var hexObject = parseHex(hashlessHex);
  var decimalObject = hexesToDecimals(hexObject);
  return formatRgb(decimalObject, a);
};

export { createOverrides, hexToRgba };
